import { gql } from '@apollo/client';

export const QUERY = gql`
  query GetActivityLog($organizationId: Int!, $memberId: Int!) {
    activityLogs(organizationId: $organizationId, memberId: $memberId) {
      id
      memberId
      organizationId
      transactedAt
      category
      action
      updaterName
      description
    }
  }
`;
